module.exports = __webpack_public_path__ + "static/media/get-started-mobile.77de98f4.svg";